<template>
  <div>
    <v-form @submit.prevent v-model="valid">
      <v-text-field
        v-model="token"
        label="Token"
        required
        :rules="[(v) => regexValidate.test(v) || 'Token inválido']"
        outlined
        placeholder="a1b2c3d4-e5f6-g7h8-f9g0-h1i2j3k4l5m6n7o8p9q0r1s2t3u4v5w6x7y8z9"
        counter
        :maxlength="100"
        :disabled="loading"
      />
      <v-text-field
        v-model="publicKey"
        label="Chave Pública"
        required
        type="tel"
        outlined
        readonly
        placeholder="Será gerada automaticamente"
        :disabled="loading"
      />

      <v-alert v-if="error" type="error" text>
        {{ error }}
      </v-alert>

      <v-alert type="info" text>
        O token será verificado automaticamente. A chave pública será gerada
        automaticamente.
      </v-alert>

      <v-btn
        color="primary"
        @click="save"
        :disabled="!valid"
        :loading="loading"
      >
        Salvar
      </v-btn>
    </v-form>
  </div>
</template>

<script>
import platformService from "@/services/admin/platform";

export default {
  name: "PagseguroSettings",
  props: {
    platform: {
      type: Object,
      required: true,
    },
    gateways: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      error: null,
      valid: false,
      loading: false,
      token: "",
      publicKey: "",
      regexValidate:
        /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{48}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/,
    };
  },
  methods: {
    async save() {
      try {
        this.loading = true;
        this.error = null;
        const response = await platformService.updateGateway(
          this.platform.id,
          "pagseguro",
          {
            token: this.token,
          }
        );

        const publicKey = response.data.find(
          (item) => item.key === "publicKey"
        );
        if (publicKey) this.publicKey = publicKey.value;

        this.$emit("update:valid", true);
      } catch (error) {
        this.error = error.message || "Erro ao salvar configurações";
        this.$emit("update:valid", false);
      } finally {
        this.loading = false;
      }
    },
    load() {
      this.token = this.gateways.pagseguro.token;
      this.publicKey = this.gateways.pagseguro.publicKey;
      this.$emit("update:valid", !!this.gateways.pagseguro.publicKey);
    },
  },
  watch: {
    token: {
      handler(val, oldVal) {
        if (!oldVal) return;
        this.publicKey = "";
        this.$emit("update:valid", false);
      },
    },
    gateways: {
      handler() {
        this.load();
      },
      deep: true,
    },
  },
  mounted() {
    this.load();
  },
};
</script>
